// attribution.js — Capture & persist UTM params + referrer for sign-up attribution
const UTM_STORAGE_KEY = 'nativus_attribution';
const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

/**
 * Call on app init (index.js). Captures UTM params from URL on first visit.
 * Only stores once — first-touch attribution.
 */
export function captureAttribution() {
  // Don't overwrite existing attribution (first-touch wins)
  if (localStorage.getItem(UTM_STORAGE_KEY)) return;

  const params = new URLSearchParams(window.location.search);
  const attribution = {};
  let hasAny = false;

  for (const key of UTM_PARAMS) {
    const val = params.get(key);
    if (val) {
      attribution[key] = val;
      hasAny = true;
    }
  }

  // Also capture referrer
  if (document.referrer && !document.referrer.includes('nativus.ro')) {
    attribution.referrer = document.referrer;
    hasAny = true;
  }

  // Capture landing page (without query params for cleanliness)
  attribution.landing_page = window.location.pathname;
  attribution.first_visit = new Date().toISOString();

  if (hasAny || attribution.landing_page !== '/') {
    localStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(attribution));
  }
}

/**
 * Get stored attribution data (returns object or null)
 */
export function getAttribution() {
  try {
    const raw = localStorage.getItem(UTM_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

/**
 * Clear attribution after it's been sent to backend (post sign-up)
 */
export function clearAttribution() {
  localStorage.removeItem(UTM_STORAGE_KEY);
}
